<div>The current completed count of passed todos is ${input.todos.filter(todo => todo.completed).length}</div>